import { useState } from "react";
import "./accordion.css";

const Accordion = ({ title, children }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="accordion">
			<button
				className={`accordion-header ${isOpen ? "open" : ""}`}
				onClick={() => setIsOpen(!isOpen)}
				aria-expanded={isOpen}
			>
				<span>{title}</span>
				<span className="accordion-icon">{isOpen ? "▾" : "▸"}</span>
			</button>
			<div className={`accordion-content ${isOpen ? "open" : ""}`}>
				<div className="accordion-inner">{children}</div>
			</div>
		</div>
	);
};

export default Accordion
